/** Opens an invoice in the same print window the invoice page uses, so the branch's template and the frozen identity apply exactly as they do there. */
export function printInvoice(invoiceId: string) {
  window.open(`/print/invoice/${invoiceId}`, '_blank', 'noopener,width=900,height=1000');
}
